import _createForOfIteratorHelper from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.splice.js";
import "regenerator-runtime/runtime.js";
import "swiper/swiper.scss";
import Swiper from "swiper";
import { defineComponent, onMounted, reactive, watch, ref, onBeforeUnmount, computed } from "vue";
import NingTips from "@/components/QuestionCard/tips.vue";
import { cloneDeep } from "lodash-es";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import EndAnswer from "./endAnswer.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
export default defineComponent({
  name: "QuestionCard",
  components: {
    NingTips: NingTips,
    EndAnswer: EndAnswer
  },
  props: {
    list: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: true
    },
    isTime: {
      type: Boolean,
      default: true
    },
    listscore: {
      type: Object,
      default: null
    },
    listtime: {
      type: Object,
      default: null
    },
    historyid: {
      type: String,
      default: ""
    },
    isNext: {
      type: Boolean,
      default: true
    },
    arrive: {
      type: String,
      default: ""
    },
    state: {
      type: String,
      default: ""
    },
    from: {
      type: String,
      default: ""
    }
  },
  emits: ["getCardChildren", "questionListChange"],
  setup: function setup(props, context) {
    var timeTF = ref(false);

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getTime();

            case 2:
              timeTF.value = true;
              setSwiper();
              getListType();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    var Data = reactive({
      questionArrIndex: 0,
      // 题目类型
      questionArr: [{
        id: 1,
        title: "单选题",
        children: [],
        isActive: true
      }, {
        id: 2,
        title: "多选题",
        children: [],
        isActive: false
      }, {
        id: 3,
        title: "判断题",
        children: [],
        isActive: false
      }, {
        id: 4,
        title: "填空题",
        children: [],
        isActive: false
      }],
      mySwiperIndex: 0,
      alphabet: ["A", "B", "C", "D"],
      answer: [],
      questionList: [],
      inputBox: 0,
      isInputState: "blur",
      listTime: {
        finishTime: "",
        duration: "",
        remain: ""
      },
      deleteLength: 0
    });
    var mySwiper; // 若没有单选题，tabs选中会有问题，深度监听

    var firstLoad = ref(true);
    watch(function () {
      return Data.questionArr;
    }, function (newVal) {
      if (firstLoad.value == false) {
        return;
      }

      var state = true;

      for (var index in newVal) {
        if (state == true) {
          if (newVal[index].children.length > 0) {
            state = false;
            Data.questionArrIndex = Number(index);
            newVal[index].isActive = true;
            firstLoad.value = false;
          } else {
            newVal[index].isActive = false;
          }
        }
      }
    }, {
      immediate: true,
      deep: true
    }); // 获取时间缓存

    var getTime = function getTime() {
      if (sessionStorage.getItem("duration")) {
        Data.listTime.duration = Number(sessionStorage.getItem("duration"));
      }
    }; // 根据传过来的数组进行操作


    var getListType = function getListType() {
      for (var _i = 0, _Object$keys = Object.keys(props.listtime); _i < _Object$keys.length; _i++) {
        var v = _Object$keys[_i];
        Data.listTime[v] = props.listtime[v];
      }

      Data.questionList = props.list;
      Data.answer = []; // 如果是考试状态，触发计时器

      if (props.disabled == true) {
        console.log("触发计数器");
        getExamTimeout();
      }

      var _iterator = _createForOfIteratorHelper(Data.questionList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _v = _step.value;

          if (_v.type != 2) {
            // Data.answer.push({ id: "", answer: "" });
            Data.answer.push({
              id: _v.questionId,
              // answer: props.disabled==true?"":v.answer as string | string[],
              answer: props.disabled == true ? "" : String(_v.reply),
              historyId: props.historyid,
              index: -1,
              type: _v.type
            });
          } else {
            // Data.answer.push({ id: "", answer: [] });
            if (!_v.reply) {
              _v.reply = "";
            }

            Data.answer.push({
              id: _v.questionId,
              answer: props.disabled == true ? [] : _v.reply.split(","),
              historyId: props.historyid,
              index: -1,
              type: _v.type
            });
          }

          if (_v.type == 4) {
            // v.answerArr = "";
            _v.answerArr = props.disabled == true ? "" : _v.answer;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      for (var index in Data.questionList) {
        Data.answer[index].index = Number(index + 1);
        Data.questionArr[Data.questionList[index].type - 1].children.push(Number(index) + 1);
      }
    }; // 点击事件,跳转到对应的题


    var titleClick = function titleClick(item) {
      mySwiper.slideTo(item - 1, 0, true);
    }; // tabs点击事件


    var tabsClick = function tabsClick(item, index) {
      Data.questionArrIndex = index;

      var _iterator2 = _createForOfIteratorHelper(Data.questionArr),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var v = _step2.value;
          v.isActive = false;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      item.isActive = true;
    }; // 挂载swiper


    var setSwiper = function setSwiper() {
      mySwiper = new Swiper(".swiper-container", {
        autoplay: false,
        loop: false,
        speed: 0,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets"
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoHeight: true,
        observer: true,
        on: {
          slideChangeTransitionEnd: function slideChangeTransitionEnd(swiper) {
            // 获取当前索引
            Data.mySwiperIndex = swiper.activeIndex;
            mySwiper.activeIndex = swiper.activeIndex;
          }
        }
      });
    };

    watch(function () {
      return Data.mySwiperIndex;
    }, function () {
      tabsClick(Data.questionArr[Data.questionList[Data.mySwiperIndex].type - 1], Data.questionList[Data.mySwiperIndex].type - 1);
    });
    watch(function () {
      return Data.questionList[Data.mySwiperIndex];
    }, function () {
      var _Data$questionList$Da, _Data$questionList$Da2, _Data$questionList$Da3, _Data$questionList$Da4;

      if (((_Data$questionList$Da = Data.questionList[Data.mySwiperIndex]) === null || _Data$questionList$Da === void 0 ? void 0 : (_Data$questionList$Da2 = _Data$questionList$Da.answerArr) === null || _Data$questionList$Da2 === void 0 ? void 0 : _Data$questionList$Da2.length) == ((_Data$questionList$Da3 = Data.questionList[Data.mySwiperIndex]) === null || _Data$questionList$Da3 === void 0 ? void 0 : (_Data$questionList$Da4 = _Data$questionList$Da3.answer) === null || _Data$questionList$Da4 === void 0 ? void 0 : _Data$questionList$Da4.length)) {
        var _Data$questionList$Da5, _Data$questionList$Da6;

        Data.inputBox = Number((_Data$questionList$Da5 = Data.questionList[Data.mySwiperIndex]) === null || _Data$questionList$Da5 === void 0 ? void 0 : (_Data$questionList$Da6 = _Data$questionList$Da5.answerArr) === null || _Data$questionList$Da6 === void 0 ? void 0 : _Data$questionList$Da6.length) - 1;
      } else {
        var _Data$questionList$Da7, _Data$questionList$Da8;

        Data.inputBox = Number((_Data$questionList$Da7 = Data.questionList[Data.mySwiperIndex]) === null || _Data$questionList$Da7 === void 0 ? void 0 : (_Data$questionList$Da8 = _Data$questionList$Da7.answerArr) === null || _Data$questionList$Da8 === void 0 ? void 0 : _Data$questionList$Da8.length);
      }
    }, {
      immediate: true,
      deep: true
    }); // 上一题下一题

    var toggledSwiper = function toggledSwiper(name) {
      if (name == "prev") return mySwiper.slidePrev();
      if (name == "next") return mySwiper.slideNext();
    }; // 交卷


    var handleSubmit = function handleSubmit(state) {
      var giveValue = getSubmit();

      if (props.arrive == '知识测试') {
        context.emit("getCardChildren", giveValue[Data.questionArrIndex], state);
      } else {
        context.emit("getCardChildren", giveValue, state);
      }
    }; // 交卷时将Data.questionList里面的关于填空题的回答赋值给answer


    var getSubmit = function getSubmit() {
      // 利用lodash的深拷贝拷贝一下没有关联关系的数据，传给父组件
      var giveValue = cloneDeep(Data.answer);

      for (var i = 0; i < Data.questionList.length; i++) {
        if (Data.questionList[i].type == 2) {
          giveValue[i].answer = giveValue[i].answer.join(",");
        }

        if (Data.questionList[i].type == 4) {
          giveValue[i].answer = String(Data.questionList[i].answerArr);
        }
      }

      return giveValue;
    }; // 判断input聚焦状态


    var isInputClick = function isInputClick(name) {
      Data.isInputState = name;
    }; // 判断问题的类型


    var isQuestionType = function isQuestionType(type) {
      if (type == 1) return "单选题";
      if (type == 2) return "多选题";
      if (type == 3) return "判断题";
      if (type == 4) return "填空题";
    }; // 获取每种类型题的总分


    var getFullScore = function getFullScore(item, score) {
      return Number(item.children.length) * Number(score);
    }; // 定时器，判断考试时间是否到期


    var myTimer = ref({
      setInterval: [],
      setTimeout: []
    }); // 考试提醒

    var getExamTimeout = function getExamTimeout() {
      if (props.disabled == false) return; // 考试时间 试卷结束时间
      // if (Data.listTime.duration <= Data.listTime.remain) {
      // 计时器：如果超时自动交卷

      var number = Number(sessionStorage.getItem("duration"));
      getAutoPaper(number); // 如果考试时间大于将要考试试卷结束的时间
      // } else {
      // 如果考试时间小于将要考试试卷结束的时间
      // getAutoPaper(Data.listTime.remain);
      // getExamTip(Data.listTime.remain);
      // }
    }; // 延时器：用来提示考试提醒(多处用到，封装函数)


    var getExamTip = function getExamTip(number) {
      // 如果考试时间大于5分钟，当考试时间仅剩五分钟时进行提醒
      if (Number(number) > 5) {
        var timer = setTimeout(function () {
          ElMessage.warning("您的考试时间剩余5分钟");
        }, Number(number) * 60 * 1000 - 5 * 60 * 1000); // 将设置的延时器添加到myTimer对象中

        myTimer.value.setTimeout.push(Number(timer));
      } else {
        // 考试时间小于5分钟，直接进行提醒考试时间不足五分钟
        ElMessage.warning("您的考试时间不足5分钟");
      }
    }; // 考试超时自动交卷 单位：分钟


    var getAutoPaper = function getAutoPaper(number) {
      console.log("开始计时"); // 分钟计时器

      var timer = setInterval(function () {
        if (number > 0) {
          number = Number(number) - 1;

          if (number == 0) {
            Data.listTime.duration = 0;
            clearTimer();
            handleSubmit(false);
            return false;
          }

          sessionStorage.setItem("duration", String(number));
          Data.listTime.duration = number; // store.commit("annualCheck/examTimeChange", number);
          // Data.listTime.duration = Number(Data.listTime.duration) - 1;

          if (number == 5) {
            ElMessage.warning("\u8BD5\u5377\u5C06\u57285\u5206\u949F\u540E\u7ED3\u675F\uFF0C\u6CE8\u610F\u8003\u8BD5\u65F6\u95F4");
          }
        } else {
          number = 0;
          clearTimer();
          handleSubmit(false);
        } // }, 1000 * 1);

      }, 1000 * 60);
      myTimer.value.setInterval.push(Number(timer));
    }; // 考试超时自动交卷
    // 注销所有计时器和定时器


    var clearTimer = function clearTimer() {
      var _iterator3 = _createForOfIteratorHelper(myTimer.value.setInterval),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var v = _step3.value;
          clearInterval(v);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var _iterator4 = _createForOfIteratorHelper(myTimer.value.setTimeout),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _v2 = _step4.value;
          clearTimeout(_v2);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    };

    onBeforeUnmount(function () {
      clearTimer();
    });

    var init = function init(item) {// 
    };

    var selectImage = computed(function () {
      return function (index, item) {
        var obj = {
          opacity: 1,
          name: 1
        };
        var init = index + 1;
        var initArr = [String(item.answer), String(item.reply)]; // 如果答案正确

        if (item.reply == item.answer) {
          if (item.type == 1 && init == item.answer) {
            return obj;
          } else if (item.type == 2 && item.answer.indexOf(init) > -1) {
            return obj;
          } else if (item.type == 3 && item.answer == init - 1) {
            return obj;
          } else {
            obj.name = 0;
          }
        } else if (item.reply == "") {
          if (item.type == 1 && init == item.answer) {
            obj.name = 2;
            return obj;
          }

          if (item.type == 2 && item.answer.indexOf(init) > -1) {
            obj.name = 1;
            return obj;
          }

          if (item.type == 3 && item.answer.indexOf(index) > -1) {
            obj.name = 2;
            return obj;
          }

          obj.name = 0;
          return obj;
        } else {
          if (item.type == 1) {
            // 如果答案不正确
            var state = init == item.answer; //state：true表示这个为正确的，否则为错误的

            if (initArr.includes(String(init))) {
              state ? obj.name = 1 : obj.name = 2;
              return obj;
            }

            obj.name = 0;
          }

          if (item.type == 2) {
            var _state = item.answer.indexOf(String(init)) > -1; //state：true表示这个为正确的，否则为错误的


            if (_state) {
              _state ? obj.name = 1 : obj.name = 0;
              return obj;
            }

            if (item.answer.indexOf(init) > -1) {
              obj.name = 2;
              return obj;
            } else if (item.reply.indexOf(init) > -1) {
              obj.name = 2;
              return obj;
            }

            obj.name = 0;
          }

          if (item.type == 3) {
            // 如果答案不正确
            var _state2 = init - 1 == item.answer; //state：true表示这个为正确的，否则为错误的


            if (item.reply == "" && init - 1 != item.answer) {
              obj.opacity = 0;
              return obj;
            }

            if (init - 1 == item.answer || init - 1 == item.reply) {
              _state2 ? obj.name = 1 : obj.name = 2;
            }
          }
        }

        return obj;
      };
    });

    var handleMove = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var p, res, arrIndex, spliceVal, spliceIndex, i, val;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                p = Data.questionList[Data.mySwiperIndex];
                _context2.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMistakesDeleteOther"]({
                  mistakesId: p.mistakesId
                });

              case 3:
                res = _context2.sent;

                if (res.code == 0) {
                  ElMessage.success("\u5220\u9664\u6210\u529F");
                  Data.questionList.splice(Data.mySwiperIndex, 1);
                  arrIndex = Data.questionArrIndex;
                  spliceVal = Data.mySwiperIndex + 1;
                  spliceIndex = 0;

                  for (i = 0; i < Data.questionArr[arrIndex].children.length; i++) {
                    val = Data.questionArr[arrIndex].children[i];

                    if (val == spliceVal) {
                      spliceIndex = i;
                    }
                  } // Data.questionArr.splice(Data.mySwiperIndex,1)


                  Data.questionArr[arrIndex].children.splice(spliceIndex, 1);
                  Data.deleteLength++;
                  context.emit("questionListChange", Data.questionList.length);
                } else {
                  ElMessage.error("\u5220\u9664\u5931\u8D25");
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function handleMove() {
        return _ref2.apply(this, arguments);
      };
    }();

    return {
      Data: Data,
      getListType: getListType,
      timeTF: timeTF,
      titleClick: titleClick,
      tabsClick: tabsClick,
      toggledSwiper: toggledSwiper,
      handleSubmit: handleSubmit,
      isInputClick: isInputClick,
      isQuestionType: isQuestionType,
      getSubmit: getSubmit,
      getFullScore: getFullScore,
      getExamTimeout: getExamTimeout,
      getAutoPaper: getAutoPaper,
      getExamTip: getExamTip,
      clearTimer: clearTimer,
      getTime: getTime,
      firstLoad: firstLoad,
      init: init,
      selectImage: selectImage,
      handleMove: handleMove
    };
  }
});